import React, {useEffect,useState} from 'react'
import './Contactbtn.css'
import Aos from 'aos'
import 'aos/dist/aos.css'
import axios from 'axios'
import { Link } from 'react-router-dom'

const Contactbtn = () => {

    const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbza9_l3eedwQmA70JDyNlBvYoZnUEJe0ZO4YezX9dIUiZ74T74vIz5Eat9U9zLJTg/exec';
    const [discordLink, setDiscordLink] = useState("");
    useEffect(() => {
        fetchLink();
    }, []);

    const fetchLink = async () => {
        try {
            const response = await axios.get(SCRIPT_URL, {
                params: {
                    type: "discord"
                }
            });
            setDiscordLink(response.data);
        } catch (error) {
            console.error('Error fetching link:', error);
        }
    };

    useEffect(() => {
        Aos.init({
            duration: 900
        })
      }, []);
      
    return (
        <>
            <div className='contact-button' data-aos="zoom-out">
                    <button  className='contact-btn' >
                        <Link className='contact-button-link' to={"/creatorcircle"}>
                            <p className='contact-btn-header' data-aos="zoom-out">I would like to join the creator circle</p>
                        </Link>
                    </button>
                    <button className='contact-btn' >
                        <a className='contact-button-link' href={discordLink} target='_blank' rel="noreferrer">
                            <p className='contact-btn-header' data-aos="zoom-out">I would like to meet more creators and grow with them</p>
                        </a>
                    </button>
            </div>
            <div className='contact-greet'>
                <i className='greet-text'>Get in touch, stay in touch</i>
            </div>
        </>
    )
}

export default Contactbtn